import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import { Component, Prop } from 'vue-property-decorator';
import EntityTableProvider from '@shared/components/tables/entity-table-provider/entity-table-provider.vue';
import EntityTable from '@shared/components/tables/entity-table/entity-table.vue';
import BpcPageTitle from '@shared/layouts/components/page-title/page-title.vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import { ValidationObserver } from 'vee-validate';
import { mixins } from 'vue-class-component';
import AbstractTable from '@shared/components/tables/abstract-table/abstract-table';
import StdFilter from '@shared/components/filters/std-filter/std-filter.vue';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSync } from '@fortawesome/free-solid-svg-icons';
import { Activity } from '@modules/activities/interfaces/activity';
import BpcDrawerModal from '@shared/components/modals/drawer-modal/drawer-modal.vue';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider';
import CustomFilterSelector from '@shared/components/filters/custom-filter-selector/custom-filter-selector.vue';
import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import BulkRecoverModal from '@shared/components/modals/bulk-recover-modal/bulk-recover-modal.vue';
import BulkMoveToTrashModal from '@shared/components/modals/bulk-move-to-trash-modal/bulk-move-to-trash-modal.vue';
import { CenterSetting } from '@core/interfaces/center-setting';
import ModulesHelper from '@core/services/modules.helper';

library.add(faSync);

@Component({
  name: 'bpc-activity-table',
  components: {
    'bpc-entity-table-provider': EntityTableProvider,
    'bpc-entity-table': EntityTable,
    'bpc-page-title': BpcPageTitle,
    'font-awesome-icon': FontAwesomeIcon,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
    'bpc-std-form': StdForm,
    'bpc-std-filter': StdFilter,
    ValidationObserver,
    'bpc-drawer-modal': BpcDrawerModal,
    'bpc-custom-filter-selector': CustomFilterSelector,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-bulk-recover-modal': BulkRecoverModal,
    'bpc-bulk-move-to-trash-modal': BulkMoveToTrashModal,
  },
})
export default class ActivityTable extends mixins(AbstractTable) {
  $refs: AbstractTable['$refs'] & {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdCloneActivitiesForm: InstanceType<typeof StdForm> & {
      formModel: AnyEntity;
      formProvider: EntityFormProvider;
    };
  };

  @Prop(String) readonly displayConfigName: string;
  @Prop(String) readonly title: string;
  @Prop(String) readonly subtitle: string;

  @Prop({ type: String, default: null }) readonly categoryFilterConfigName: string;
  @Prop({ type: Object, default: null }) readonly initialModel: AnyEntity;

  public entity: Activity = null;
  public entityName = 'bpc-activity';
  public pluralEntityName = 'bpc-activities';
  public showDrawerSettingSection: boolean = false;
  public showSettingForm: boolean = false;
  public permissionEntityNameToUse = 'activities';
  public errorBulkCloneMessageText: string = 'global.generic.error_form_action';
  public showDrawerLarge: boolean = false;

  customRowActions = {
    details: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'details',
    },
    publicDetails: {
      activated: true,
      type: 'action',
      icon: 'eye',
      show: true,
      text: 'details',
      event: 'public-details',
    },
    enroll: {
      activated: true,
      type: 'action',
      icon: 'plus',
      show: true,
      text: 'enroll',
      event: 'enroll',
    },
    manage: {
      activated: true,
      type: 'action',
      icon: 'cog',
      variant: 'primary',
      text: 'manage',
      show: true,
      event: 'manage',
      selectElements: true,
      permissions: ['show'],
    },
  };

  public customPageActions = {
    bulkClone: {
      activated: false,
      type: 'action',
      icon: 'clone', //'times',
      variant: 'info',
      text: 'clone',
      show: true,
      event: 'bulk-clone',
      selectElements: true,
      tag: 'left',
      permissions: ['store'],
    },
  };

  get pageActions() {
    return {
      ...this.customPageActions,
      ...this.defaultPageActions,
    };
  }

  // COMPUTED
  get centerSetting(): CenterSetting {
    return this.$store.getters['centerSettings/centerSettings'];
  }

  get showActivityManagementPage(): boolean {
    return this.centerSetting?.show_activity_management_page;
  }

  customOnPageAction($event: string) {
    switch ($event) {
      case 'bulk-clone':
        this.onBulkClone();
        break;
    }
  }

  onBulkClone() {
    this.$bvModal.show('modal-clone-activities');
  }

  onConfirmBulkClone() {
    const basePath = this.$bpcApiRouteHelper.getEntityPath('bpc-activities');
    const ids = this.selection;

    this.$bpcApi
      .post(basePath + '/clone', {
        ids: ids,
        days_lag: this.$refs.stdCloneActivitiesForm.formModel['days_lag'],
      })
      .subscribe(
        () => {
          this.$refs.provider.getEntities();
          this.$bvModal.hide('modal-clone-activities');
        },
        () => {
          this.$bpcMessage.showErrorMessage({ text: this.errorBulkCloneMessageText });
          // this.$bvModal.hide('modal-generate-invoices');
        },
      );
  }

  onCloseBulkCloneModal() {
    this.$bvModal.hide('modal-clone-activities');
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Activity;
    Object.keys(this.entity).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.entity.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);

    this.showForm = true;
    this.showDrawerSection = true;
  }

  onNew() {
    this.$bpcStorage.clear('activity-groups');
    this.$bpcStorage.clear('enrollments');
    this.showDrawerLarge = false;
    this.entity = null;
    this.showForm = true;
    this.showDrawerSection = true;
    this.disabledForm = false;
  }

  onEdit(e, disabled = false) {
    this.$bpcStorage.clear('activity-groups');
    this.$bpcStorage.clear('enrollments');
    this.showDrawerLarge = true;
    this.entity = e.item;
    this.showForm = true;
    this.showDrawerSection = true;
    setTimeout(() => {
      this.disabledForm = disabled;
    });
  }

  customOnRowAction($event: { event: string; item: any }) {
    const actionName = $event.event === 'public-details' ? 'publicDetails' : $event.event;
    if ($event.item.item.actions[actionName].activated) {
      switch ($event.event) {
        case 'edit':
          if (this.$authorizationService.hasPermission('manage_enrollments')) {
            this.onEdit($event.item, false);
          }
          break;
        case 'details':
          this.$router.push({
            name: 'public-activity-details',
            params: { alias: $event.item.item.alias },
          });
          break;
        case 'public-details':
          this.$router.push({
            name: 'profile-activity-details',
            params: { alias: $event.item.item.alias },
          });
          break;
        case 'enroll':
          this.$router.push('activity-details/' + $event.item.item.id);
          break;
        case 'manage':
          this.$router.push({
            name: 'admin-activities-manage',
            params: { activity_id: $event.item.item.id },
          });
          break;
      }
    }

    console.log('custom Row action event >>> ' + $event.event);
  }

  extendUpdateRowActions(entity: any) {
    if (!this.$authorizationService.hasRole('contact')) {
      entity.actions.enroll.activated = false;
    }

    entity.actions['details'].show =
      this.isCmsModuleActivated &&
      this.allowAccessPublicWebpage &&
      this.hasHomepage &&
      this.tableIsNotFilteredByTrashedElements() &&
      this.$authorizationService.hasPermission('manage_activity_sessions');

    entity.actions['manage'].show =
      this.$refs.provider &&
      this.showActivityManagementPage &&
      this.tableIsNotFilteredByTrashedElements();

    return null;
  }

  // Bulk restore modal (recover)
  showBulkRecoverModal = false;
  onBulkRecover() {
    this.showBulkRecoverModal = true;
  }
  onCLoseBulkRecover() {
    this.showBulkRecoverModal = false;
  }
  onSuccessBulkRecover() {
    this.$refs.provider.getEntities();
  }

  bulkRecoverDataToShow = [['code', 'name']];
  // Bulk soft delete modal (move to trash)
  showBulkMoveToTrashModal = false;
  onBulkSoftDelete() {
    this.showBulkMoveToTrashModal = true;
  }
  onCLoseBulkSoftDelete() {
    this.showBulkMoveToTrashModal = false;
  }
  onSuccessSoftDelete() {
    this.$refs.softDeleteConfirmationModal.onCloseModal();
    this.$refs.provider.getEntities();
  }
  bulkMoveToTrashDataToShow = [['code', 'name']];

  get isCmsModuleActivated(): boolean {
    return this.$modulesService.hasModuleActivated(ModulesHelper.CMS_MODULE_NAME);
  }
  get hasHomepage(): boolean {
    return !!this.$store.getters['centerSettings/centerSettings']?.has_homepage;
  }
  get allowAccessPublicWebpage(): boolean {
    return !!this.$store.getters['centerSettings/centerSettings']?.allow_access_public_website;
  }
}
